module.exports = __webpack_public_path__ + "img/btn_home_magazine.19139ee3.png";